module.exports = __webpack_public_path__ + "static/media/header-bg.e1314cf3.jpg";